import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.css']
})
export class FormModalComponent {
  @Input() title: string = "";
  @Input() subTitle: string ="";
  @Input() fields: any[] = []
  @Output() fieldsChange = new EventEmitter<any[]>();
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>()
  @Input() actionButtonTitle: string = "Deactivate"
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>()
  action(): void {
		this.toggleModal()
		this.onSave.emit()
	}

  toggleModal(): void {
		this.onCancel.emit()
	}


  onChange(index:number, value: string){
    this.fields[index].value = value;
    this.fieldsChange.emit(this.fields);
  }
}
